import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { gymInfo } from '../mock';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3 className="footer-title">
              <span className="logo-text">TEAM KENT</span>
              <span className="logo-accent">BOXING INTERNATIONAL GYM</span>
            </h3>
            <p className="footer-description">
              Transform your body, mind, and fighting spirit. Train with champions, become a champion.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <div className="footer-links">
              <Link to="/programs" className="footer-link">Programs</Link>
              <Link to="/coaches" className="footer-link">Coaches</Link>
              <Link to="/booking" className="footer-link">Book Session</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact Info</h4>
            <div className="footer-contact">
              <div className="footer-contact-item">
                <MapPin size={18} />
                <span>{gymInfo.address}</span>
              </div>
              <div className="footer-contact-item">
                <Phone size={18} />
                <span>{gymInfo.phone}</span>
              </div>
              <div className="footer-contact-item">
                <Mail size={18} />
                <span>{gymInfo.email}</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Hours</h4>
            <div className="footer-hours">
              <div className="footer-hours-item">
                <Clock size={18} />
                <div>
                  <p><strong>Mon-Fri:</strong> {gymInfo.hours.weekday}</p>
                  <p><strong>Saturday:</strong> {gymInfo.hours.saturday}</p>
                  <p><strong>Sunday:</strong> {gymInfo.hours.sunday}</p>
                  <p><strong>Public Holidays:</strong> {gymInfo.hours.publicHolidays}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Team Kent Boxing International Gym. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;